import {useSelector} from 'react-redux'
import {getLanguageCode} from 'modules/meta/selectors'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {getLocalizedFooterUrl} from '@vio/core/src/brand/utils'

export const useHowItWorks = () => {
  const {brand} = useBrand()
  const {
    shell: {showsHowItWorksLink}
  } = useBrandCapabilities()
  const languageCode = useSelector(getLanguageCode)
  const {howItWorksUrl} = brand.links

  return {
    isEnabled: showsHowItWorksLink && Boolean(howItWorksUrl),
    link: getLocalizedFooterUrl(howItWorksUrl, languageCode)
  }
}
